import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=70e38597&scoped=true&"
import script from "./ProfilesList.vue?vue&type=script&lang=js&"
export * from "./ProfilesList.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesList.vue?vue&type=style&index=0&id=70e38597&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e38597",
  null
  
)

export default component.exports